import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface BubblePoint {
  x: number;
  y: number;
  size: number;
  name?: string;
}

interface BubbleChartProps {
  data: BubblePoint[];
  height?: number | string;
  loading?: boolean;
}

export function BubbleChart({ data, height, loading }: BubbleChartProps) {
  const maxSize = Math.max(...data.map((d) => d.size), 1);
  const option: EChartsOption = {
    tooltip: { trigger: 'item', formatter: (p: any) => `${p.name}<br/>x: ${p.value[0]}<br/>y: ${p.value[1]}<br/>size: ${p.value[2]}` },
    grid: { left: 40, right: 20, top: 20, bottom: 40, containLabel: true },
    xAxis: { type: 'value' },
    yAxis: { type: 'value' },
    series: [{
      type: 'scatter',
      data: data.map((d) => ({ name: d.name, value: [d.x, d.y, d.size] })),
      symbolSize: (val: any) => (val[2] / maxSize) * 60 + 10,
      itemStyle: { opacity: 0.7 },
    }],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
